import { render } from "./index.vue?vue&type=template&id=5a50d54a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5a50d54a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bitty-h5-online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a50d54a"]])

export default __exports__